'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { getOptimizedImageUrl, handleImageError } from '@src/utils/getOptimizedImageUrl';
import { getLatestMediaUrl } from '@src/utils/getLatestMediaUrl';

import BaseComponent from '../../views/shared/base';
import { Layout } from '../layouts/layout/layout';

import {
    ItemDetailMainComponent,
    mapStateToProps,
    mapDispatchToProps
} from '../features/pricing_type/service_level/item-details/index';

class ItemDetailComponent extends BaseComponent {
    getUserMedia(user) {
        return getLatestMediaUrl(user);
    }

    addReplyClick(feedbackId) {
        this.itemDetail.props.addReplyFeedBack(feedbackId);
        $('#replyModal').modal('hide');
    }

    renderPopUp() {
        let self = this;
        if (this.props.feedback) {
            let review = {};
            this.props.feedback.ItemReviews.map(function (data) {
                if (data.isSelected && data.isSelected === true) {
                    review = data;
                }
            });
            if (JSON.stringify(review) !== '{}') {
                return (
                    <div id='replyModal' className='modal fade' role='dialog'>
                        <div className='modal-dialog'>
                            {/* Modal content*/}
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <button type='button' className='close' data-dismiss='modal'>
                                        ×
                                    </button>
                                    <h4 className='modal-title'>REPLY TO: </h4>
                                </div>
                                <div className='modal-body'>
                                    <div className='review-box'>
                                        <div className='user-avtar'>
                                            {' '}
                                            <a href='#'>
                                                <img
                                                    src={getOptimizedImageUrl('avatar', review.User?.ID, 0, 'medium') || self.getUserMedia(review.User)}
                                                    alt=''
                                                    onError={(e) => handleImageError(e, self.getUserMedia(review.User))}
                                                />
                                            </a>{' '}
                                        </div>
                                        <div className='review-detail'>
                                            <div className='review-head'>
                                                <h6>
                                                    <b>{`${review.User.FirstName} ${review.User.LastName}`}</b>
                                                </h6>
                                                <div className='text-right item-rating float-right'>
                                                    <span className='stars'>
                                                        <span style={{ width: `${review.ItemRating * 20}%` }} />
                                                    </span>
                                                </div>
                                                {/* <div class="item-rating text-right"><img align="absmiddle" src="images/star_positive.svg"> <img align="absmiddle" src="images/star_positive.svg"> <img align="absmiddle" src="images/star_positive.svg"> <img align="absmiddle" src="images/star_positive.svg"> <img align="absmiddle" src="images/star_negative.svg"></div> */}
                                                <p>
                                                    {self.formatDateTime(review.CreatedDateTime, 'DD/MM/YYYY, hh:mm')}
                                                </p>
                                            </div>
                                            <div className='review-body'>{review.Message}</div>
                                        </div>
                                    </div>
                                    <div className='comment-area'>
                                        <textarea
                                            rows={8}
                                            className='form-control'
                                            onChange={e => this.itemDetail.props.updateMessage(e.target.value)}
                                            placeholder='Leave a comment...'
                                            defaultValue={this.itemDetail.props.message}
                                        />
                                    </div>
                                </div>
                                <div className='text-center modal-footer'>
                                    <button
                                        type='button'
                                        onClick={e => this.addReplyClick(review.FeedbackID)}
                                        className='btn btn-secondary'
                                    >
                                        Reply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div id='replyModal' className='modal fade' role='dialog'>
                        <div className='modal-dialog'>
                            {/* Modal content*/}
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <button type='button' className='close' data-dismiss='modal'>
                                        ×
                                    </button>
                                    <h4 className='modal-title'>REPLY TO: </h4>
                                </div>
                                <div className='modal-body'>
                                    <div className='review-box'>
                                        <div className='user-avtar'>
                                            {' '}
                                            <a href='#'>
                                                <img src='images/place_user.jpg' alt='images' />
                                            </a>{' '}
                                        </div>
                                        <div className='review-detail'>
                                            <div className='review-head'>
                                                <h6>
                                                    <b>Buyer1</b>
                                                </h6>
                                                <div className='text-right item-rating float-right'>
                                                    <span className='stars'>
                                                        <span style={{ width: '99px' }} />
                                                    </span>
                                                </div>
                                                {/* <div class="item-rating text-right"><img align="absmiddle" src="images/star_positive.svg"> <img align="absmiddle" src="images/star_positive.svg"> <img align="absmiddle" src="images/star_positive.svg"> <img align="absmiddle" src="images/star_positive.svg"> <img align="absmiddle" src="images/star_negative.svg"></div> */}
                                                <p>DD/MM/YYYY, HH:MM</p>
                                            </div>
                                            <div className='review-body'>
                                                This seller is great, really recommended to buy from him, 10/10 will buy
                                                again.
                                            </div>
                                        </div>
                                    </div>
                                    <div className='comment-area'>
                                        <textarea
                                            rows={8}
                                            className='form-control'
                                            placeholder='Leave a comment...'
                                            defaultValue=''
                                        />
                                    </div>
                                </div>
                                <div className='text-center modal-footer'>
                                    <button type='button' className='btn btn-secondary'>
                                        Reply
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <Layout user={this.props.user} categories={this.props.categories} panels={this.props.panels}>
                    <ItemDetailMainComponent {...this.props} />
                </Layout>
            </React.Fragment>
        );
    }
}

const ItemDetailsHome = connect(mapStateToProps, mapDispatchToProps)(ItemDetailComponent);

export { ItemDetailsHome, ItemDetailComponent };

export default {
    ItemDetailsHome,
    ItemDetailComponent
};
